import produce from 'immer';
import React, { ReactNode, useMemo, useState } from 'react';
import { AssetState, ThreekitApiData, ThreekitApiOptions } from '../types';
import { isEqualWith } from 'lodash';

// const assetMap: Map<string, ThreekitApiData> = new Map();

// let apiState: { [key: string]: ThreekitApiData } = produce({}, () => {});

interface ThreekitApiContextState {
  apiState: { [key: string]: ThreekitApiData };
  setAssetRef: (id: string, data: ThreekitApiData) => void;
  getAssetRef: (id: string) => ThreekitApiData | undefined;
}

let apiState: { [key: string]: ThreekitApiData } = produce({}, () => {});

const defaultOptions = { skipFiles: false, useConfigurator: false };

// let contextState: ThreekitApiContextState = produce(
//   {
//     apiState: {},
//     options: { skipFiles: false, useConfigurator: false },
//     setAssetRef,
//     getAssetRef,
//   },
//   () => {}
// );

function doSetAssetRef(id: string, data: Partial<ThreekitApiData>) {
  const result = apiState[id];
  apiState = produce(apiState, (draftState) => {
    draftState[id] = { ...result, ...data };
  });
}

function getAssetRef(id: string) {
  return apiState[id];
}

// const defaultContext = {
//   apiState,
//   options: { skipFiles: false, useConfigurator: false },
//   setAssetRef,
//   getAssetRef,
// };

const ThreekitApiContext = React.createContext({
  apiState,
  options: { skipFiles: false, useConfigurator: false },
  setAssetRef: doSetAssetRef,
  getAssetRef,
});

export { ThreekitApiContext };

interface ThreekitApiProps {
  skipFiles?: boolean;
  useConfigurator?: boolean;
}

type PropsWithChildren<P> = P & { children?: ReactNode };

function isShallowEqual(
  v: Partial<ThreekitApiData>,
  o: Partial<ThreekitApiData>
) {
  if (v.inputAssetState !== o.inputAssetState) return false;
  if (v.evaluatedAsset !== o.evaluatedAsset) return false;
  // const keys = ['assetState','evaluatedAsset'];
  // for (var key in v) if (!(key in o) || v[key] !== o[key]) return false;

  // for (var key in o) if (!(key in v) || v[key] !== o[key]) return false;

  return true;
}

export default function ThreekitApi(
  props: PropsWithChildren<ThreekitApiProps>
) {
  const [v, setV] = useState(0);
  const value = {
    apiState,
    options: defaultOptions,
    setAssetRef: (id: string, data: Partial<ThreekitApiData>) => {
      const result = getAssetRef(id);
      // console.log('setAssetRef', result, data);
      if (!result || !isShallowEqual(result, data)) {
        // console.log('asset changed', id, v + 1);
        doSetAssetRef(id, data);
        setV(v + 1);
      }
    },
    getAssetRef,
  };

  return (
    <ThreekitApiContext.Provider value={value}>
      {props.children}
    </ThreekitApiContext.Provider>
  );
}
